import { Platform } from 'react-native';
import * as amplitudeWeb from '@amplitude/analytics-browser';
import { sessionReplayPlugin } from '@amplitude/plugin-session-replay-browser';
import {
	init,
	setUserId,
	track,
	getDeviceId,
  identify,
  Identify
} from '@amplitude/analytics-react-native';



export function getAmplitudeDeviceID() {
  if(Platform.OS === 'web') {
    // return amplitude.getInstance().options.deviceId
    return amplitudeWeb.getDeviceId();
  } else {
    return getDeviceId();
  }
}


export const initAmplitude = ({userId = '' , token =''} : { userId : string , token? : string}): void => {
  if (Platform.OS === 'web') {
    // Always initialize with token first
    if (token) {
      console.log('Amplitude is initialized with token', token);

      amplitudeWeb.init(token, undefined, { 
        defaultTracking: {
          pageViews: true,
          sessions: true,
          formInteractions: false,
          fileDownloads: false,
        }
      });
      
      // Then set userId if provided
      if (userId) {
        amplitudeWeb.setUserId(userId);
      }
    } else {
      console.error('Amplitude token is required for web initialization');
    }

    const sessionReplayTracking = sessionReplayPlugin({sampleRate: 0.6});
    amplitudeWeb.add(sessionReplayTracking);
  } else {
    if (token) {
      
      init(token,'' , {
        disableCookies : true
      });
      if (userId) {
        setUserId(userId);
      }
    } else {
      console.error('Amplitude token is required for mobile initialization');
    }
  }
};

export const trackEvent = (eventName: string , eventProperties?: Record<string, any>): void => {
  try {
    if (Platform.OS === 'web') {
        try {
            const url = window?.location?.href;
            const keys = [...new URLSearchParams(url).keys()];
            const hasPlj = keys.some(key => key.startsWith("plj"));
            if(hasPlj){
              const properties = {
                ...(eventProperties ?? {}),
                ...(hasPlj ? { application_type: 'plj' } : {})
              };
              amplitudeWeb.track(eventName , properties);
            } else {
              amplitudeWeb.track(eventName , eventProperties ?? {});
            }
            // console.log('Screen Viewed web', eventName)
        } catch (error) {
            console.error('Error tracking Amplitude web event:', eventName , eventProperties);
        }
    } else {
        track(eventName , eventProperties ?? {});
        // console.log('Screen Viewed Mobile', eventName)
    }
} catch (error) {
    console.error('Error Logging event')
}
};


export const setUserProperty = (key: string, value: any): void => {
  if(Platform.OS === 'web') {
    const identifyEvent = new amplitudeWeb.Identify();
    identifyEvent.set(key, value);
    amplitudeWeb.identify(identifyEvent);
  } else {
    const identifyObj = new Identify();
    identifyObj.set(key, value);
    identify(identifyObj);
  }
};